import React from 'react';
import { Card } from "react-bootstrap";
import face_olah_zsolt from "../../assets/img/face_olah_zsolt.jpg";
import ShowMoreText from "react-show-more-text";
import proj_financial_modeling_for_stress_testing from "../../assets/img/proj_financial_modeling_for_stress_testing.png";

const Zsolt_Olah_fin_stress_test = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_financial_modeling_for_stress_testing} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_olah_zsolt}
              /* this will be the text on the banner */
              alt="Financial modeling for stress testing"
            />{" "}
            <p className="text7">Zsolt Oláh</p>
            <br />
            <p className="text8">
            Head of Department{" "}
            </p>
            <p className="text8">Central Bank of Hungary</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Stress testing is a data intensive and structured procedure in finance, aimed at 
            detecting small but potentially significant sources of vulnerabilities in the 
            financial system. Stress tests may be conducted by financial institutions to 
            audit their own capacities, or by financial regulators on supervised institutions 
            or entire financial markets to monitor developments and initiate necessary measures 
            if needed. Like most of engineered systems, financial systems have their own 
            dynamics and potential flaws which should be addressed in such an exercise. To 
            this end, financial regulators design macroeconomic scenarios and synthetic environments 
            for institutions, in which their behaviour can be modeled and their resilience tested. 
            This project focuses on such a system, comprising: i) financial modeling, ii) parameter 
            estimation, iii) designing economic scenarios, and iv) implementing and simulating these 
            scenarios on real-world data. Students will explore the current practices in this field 
            while participating in the collaborative work of stress testing in National Bank of Hungary.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Zsolt_Olah_fin_stress_test;